import { useCallback, useState } from 'react';

export const useSectionNavigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // React guarantees a stable setter; the DOM element is looked up per click.
  // scrollIntoView is a method of that element, not a captured reactive value.
  const scrollToSection = useCallback((id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  }, []);
  return { isMenuOpen, setIsMenuOpen, scrollToSection };
};